import React, { useEffect, useRef } from 'react';

// Eager autoplay background video (hero). React does not emit the muted
// attribute into server-rendered HTML, so browsers block autoplay on the
// prerendered page — playback must be kicked off explicitly after mount.
const AutoplayVideo = ({ src, poster, className, style }) => {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    video.muted = true;
    video.setAttribute('muted', '');
    const attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(() => {});
  }, []);

  return (
    <video
      ref={ref}
      src={src}
      poster={poster}
      className={className}
      style={style}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      aria-hidden="true"
    />
  );
};

export default AutoplayVideo;
